import React from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const SOWContractModal = ({ show, title, children, onHide, isContractFlow }) => {
  const navigate = useNavigate();
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="sow-contract-dialog"
      backdrop="static"
      keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-4">{children}</Modal.Body>
    </Modal>
  );
};

export default SOWContractModal;
